import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';
import { GetJournalEntries } from 'domain/usecases';
import { RemoteGetJournalEntries } from 'data/usecases';

export const makeRemoteGetJournalEntries = (): GetJournalEntries => {
  return new RemoteGetJournalEntries(makeApiUrl('/journal-entries'), makeAuthorizeHttpClientDecorator());
};
